import { toast } from '@mlm/ui/components/toast';

export type ShareOutcome = 'shared' | 'dismissed' | 'copied' | 'failed';

/**
 * The phone's share sheet when the browser has one, else the clipboard with a
 * toast. The coach app carries no Capacitor plugin (it may not import one), so
 * `navigator.share` is the whole native story; a dismissed sheet is not an
 * error and is never reported as one.
 */
export async function shareText(input: {
  title: string;
  text: string;
  url?: string;
}): Promise<ShareOutcome> {
  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share(input);
      return 'shared';
    } catch (err) {
      if ((err as { name?: string } | null)?.name === 'AbortError') return 'dismissed';
      // Anything else (an unsupported payload, a blocked sheet): fall back to copying.
    }
  }
  return copyText(input.url ? `${input.text}\n${input.url}` : input.text);
}

export async function copyText(text: string): Promise<'copied' | 'failed'> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Copied.');
    return 'copied';
  } catch {
    toast.error('Could not copy. Long-press the text to copy it.');
    return 'failed';
  }
}
